module.exports = __webpack_public_path__ + "assets/images/af8f32bd61f8ebee732e928041111895.png";